import { PATH_ROOT, PATH_SHIFT_REPORTS } from "@/constants";
import { ReadShiftReport } from "@/types/shiftReport";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const useShiftReportBreadcrumbs = (data?: ReadShiftReport) => {
  const { t } = useTranslation();
  const breadcrumbs = useMemo(
    () => [
      { label: t("breadcrumb.home"), href: PATH_ROOT },
      { label: t("shiftReports.title.multiple"), href: PATH_SHIFT_REPORTS },
      { label: t("shiftReports.edit", data ?? {}) },
    ],
    [t, data],
  );

  return breadcrumbs;
};
